import { useCallback, useState } from 'react';

interface ContextStateController {
  open: boolean;
  data?: any;
  anchorPosition: {left: number, top: number};
  handleClose(): void;
  handleOpen(event, data?): void;
}

interface AnchorPosition {
  left: number | null;
  top: number | null;
}

interface ContextState {
  open: boolean;
  data: any;
  anchorPosition: AnchorPosition;
}

export const useContextMenu = (): ContextStateController => {
  const [state, setState] = useState<ContextState>({
    open: false,
    data: {},
    anchorPosition: undefined
  });

  const handleOpen = useCallback((event, data = {}) => {
    event.preventDefault();

    const anchorPosition = {
      left: event.clientX + 10,
      top: event.clientY - 20
    };

    setState({
      open: true,
      data,
      anchorPosition
    });
  },[]);

  const handleClose = useCallback((): void => {
    setState({
      open: false,
      data: {},
      anchorPosition: undefined
    });
  }, []);

  return {
    open: state.open,
    data: state.data,
    anchorPosition: state.anchorPosition,
    handleClose,
    handleOpen
  };
};
